/** Plain hyphen with spaces (avoid em dash in UI copy). */
export const TEXT_SEPARATOR = " - ";

/**
 * Join non-empty string parts with {@link TEXT_SEPARATOR}.
 * Useful for list subtitles (e.g. venue and date).
 */
export function joinTextParts(
  ...parts: Array<string | null | undefined | false>
): string {
  return parts
    .filter((p): p is string => Boolean(p && String(p).trim()))
    .join(TEXT_SEPARATOR);
}
